import { createReducer } from 'reduxsauce'
import {
  UPDATE_CANVAS_VALUES,
  SET_CANVAS_INITED
} from '../types/canvas.types'
import Immutable from 'seamless-immutable'

export const INITIAL_STATE = Immutable({
  canvas: {
    x: 0,
    y: 0,
    width: 0,
    height: 0,
    scaleWidth: 0,
    scaleHeight: 0,
  },
  isCanvasInited: false
})

export const updateCanvasValues = (state, { payload: values }) => state.merge({ canvas: { ...values } }, { deep: true })
export const setCanvasInited = (state, { payload: isInited }) => state.merge({ isCanvasInited: isInited })

export const HANDLES = {
  [UPDATE_CANVAS_VALUES]: updateCanvasValues,
  [SET_CANVAS_INITED]: setCanvasInited,
}

export default createReducer(INITIAL_STATE, HANDLES)
